import { ValidationResultT } from 'Api/models/Vat';
import { ApprovalStatusT } from 'Api/models/ApprovalStatus';

export enum SchemeTypeT {
  VOEC = 'VOEC',
  VAT = 'VAT',
}

export interface SalesChannelVatInfoT {
  vatId: string;
  certificateId: string;
  approvalStatus: ApprovalStatusT;
  rejectionReason: string;
  lastValidatedAt: string;
  validationResult: ValidationResultT;
}

export interface SalesChannelVoecInfoT {
  schemeType: SchemeTypeT;
  effectiveSchemeType: SchemeTypeT;
  haveOwnVoecId: boolean;
  salesChannelId: string;
  proofCertificateId: string;
  approvalStatus: ApprovalStatusT;
  rejectionReason: string;
  modifiedAt: string;
  modifiedBy: string;
}
